import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Input } from "reactstrap";
import "./promotion.scss";
import radga from "../../assets/images/radga.png";
import { useEffect, useMemo, useState } from "react";
import DeactiveModal from "./Components/DeactiveModal";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  clearVoucherDetail,
  createVoucherConfig,
  editVoucherConfig,
  fetchVoucherDetail,
} from "live-slices/voucher/thunk";
import { createSelector } from "reselect";
import ErrorModal from "Components/Common/ErrorModal";

const CreateVoucher = (props: any) => {
  const [deActiveModal, setdeActiveModal] = useState(false);
  const [isEntireShop, setIsEntireShop] = useState(true);
  const [selectedDuration, setSelectedDuration] = useState("week");
  const [selectedCard, setSelectedCard] = useState<number>(0);
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });

  const isDuplicate = location.state?.isDuplicate || false;

  const selectVoucherData = createSelector(
    (state: any) => state.vouchers,
    (voucherData) => voucherData?.voucherData
  );

  const editData = useSelector(selectVoucherData);

  useEffect(() => {
    if (id) {
      dispatch(fetchVoucherDetail(id));
    } else {
      dispatch(clearVoucherDetail());
    }
    console.log(editData);
  }, [id]);

  const formatDateToCustomFormat = (date: Date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const handleback = () => {
    navigate(-1);
  };

  const validationSchema = useMemo(
    () =>
      Yup.object({
        promotionName: Yup.string().required("The field value is required"),
        redeemStartPeriod: Yup.string().required("The field value is required"),
        collectStartTime: Yup.string().required("The field value is required"),
        minSpendAmount: Yup.string().required("The field value is required"),
        maxDiscountPerOrder:
          selectedCard === 1
            ? Yup.string().required("The field value is required")
            : Yup.string(),
        limitPerUser: Yup.string().required("The field value is required"),
        discountAmount: Yup.string().required("The field value is required"),
        limitOfVouchers: Yup.string().required("The field value is required"),
        flatAmount:
          selectedCard === 0
            ? Yup.string().required("The field value is required")
            : Yup.string(),
        discountPercentage:
          selectedCard === 1
            ? Yup.string().required("The field value is required")
            : Yup.string(),
      }),
    [selectedCard]
  );

  const formatDateTimeLocal =  (timestamp: number | string | Date) => {
  if (!timestamp) return "";

  const date = new Date(timestamp); // handles UTC string properly
  const pad = (n: number) => n.toString().padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`; // ✅ local time
};


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      _id: editData?._id || "",
      promotionName: editData?.promotionName || "",
      products: editData?.products || "",
      productIds: editData?.productIds || [],
      redeemStartPeriod:
        !isDuplicate && editData?.redeemStartPeriod
          ? formatDateTimeLocal(editData.redeemStartPeriod)
          : "",
      redeemEndPeriod:
        !isDuplicate && editData?.redeemEndPeriod
          ? formatDateTimeLocal(editData.redeemEndPeriod)
          : "",
      collectStartTime:
        !isDuplicate && editData?.collectStartTime
          ? formatDateTimeLocal(editData.collectStartTime)
          : "",

      minSpendAmount: editData?.minSpendAmount || "",
      maxDiscountPerOrder: editData?.maxDiscountPerOrder || "",
      limitPerUser: editData?.limitPerUser || "",
      discountAmount: editData?.discountAmount || "",
      limitOfVouchers: editData?.limitOfVouchers || "",
      flatAmount: editData?.flatAmount || "",
      discountPercentage: editData?.discountPercentage || "",
      discountType: editData?.discountType || "",
      isEntireShop: editData?.isEntireShop === false ? false : true,
    },
    validationSchema,
    onSubmit: async (values: any) => {
      const updatedValues = {
        ...values,
        discountType: selectedCard === 0 ? "flatDiscount" : "percentage",
        collectStartTime: values.collectStartTime
          ? new Date(values.collectStartTime).getTime()
          : "",
        redeemStartPeriod: values.redeemStartPeriod
          ? new Date(values.redeemStartPeriod).getTime()
          : "",
        redeemEndPeriod: values.redeemEndPeriod
          ? new Date(values.redeemEndPeriod).getTime()
          : "",
        minSpendAmount: Number(values.minSpendAmount),
        maxDiscountPerOrder: Number(values.maxDiscountPerOrder),
        limitPerUser: Number(values.limitPerUser),
        discountAmount: Number(values.discountAmount),
        flatAmount: Number(values.flatAmount),
        discountPercentage: Number(values.discountPercentage),
        limitOfVouchers: Number(values.limitOfVouchers),
      };

      try {
        if (id && !isDuplicate) {
          await dispatch(editVoucherConfig(updatedValues));
          setErrorMessage("Voucher Edit Successfully!");
          setShowModal({ isVisible: true, color: true });
          setTimeout(() => {
            setShowModal({ isVisible: false, color: true });
          }, 1000);
          navigate("/promotion");
          return;
        } else {
          await dispatch(createVoucherConfig(updatedValues));
          setErrorMessage("Voucher Create Successfully!");
          setShowModal({ isVisible: true, color: true });
          setTimeout(() => {
            setShowModal({ isVisible: false, color: true });
          }, 1000);
          navigate("/promotion");
        }
      } catch (error) {
        setErrorMessage("Failed to create voucher.");
        setShowModal({ isVisible: true, color: false });
        setTimeout(() => {
          setShowModal({ isVisible: false, color: false });
        }, 1000);
        console.error(error);
      }
    },
  });

  const handleCardClick = (index: number) => {
    setSelectedCard(index);
    formik.setFieldValue("flatAmount", "");
  };

  const getMinDateTime = () => {
  const now = new Date();
  now.setSeconds(0, 0);
  return now.toISOString().slice(0, 16);
};


  const handleSetDuration = (duration: "week" | "month", baseDate?: string) => {
    setSelectedDuration(duration);

    const startDate = baseDate
      ? new Date(baseDate)
      : new Date(formik.values.redeemStartPeriod);
    if (!startDate || isNaN(startDate.getTime())) return;
    let endDate;
    if (duration === "week") {
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 7);
    } else {
      endDate = new Date(startDate);
      endDate.setMonth(startDate.getMonth() + 1);
    }
    const inputFormat = endDate.toISOString().slice(0, 16);
    const customDisplay = formatDateToCustomFormat(endDate);
    formik.setFieldValue("redeemEndPeriod", inputFormat);
    console.log("validUnitDate:", customDisplay);
  };

  const handleFieldChange = (key: string, e: any) => {
    formik.setFieldValue(key, e.target.value);
  };


  return (
    <div className="page-content Promotion-Main">
      <DeactiveModal
        show={deActiveModal}
        onCloseClick={() => setdeActiveModal(false)}
      />
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <Container fluid>
        <BreadCrumb
          title={editData?._id ? "Edit Regular Voucher " : "Create Regular Voucher "}
          pageTitle="promotion"
          pageTitleRoute="/promotion"
        />
        <form onSubmit={formik.handleSubmit}>
          <Card className="CreatVoucherCard-Main">
            <div className="INPUT">
              <div className="input-main">
                <div className="input">
                  <h1>
                    Promotion Name{" "}
                    <span style={{ color: "red", display: "inline" }}>*</span>{" "}
                  </h1>
                  <div className="formContainer">
                    <Input
                      type="text"
                      className={`form-control pe-5 password-input ${formik.touched.promotionName &&
                          formik.errors.promotionName
                          ? "is-invalid"
                          : ""
                        }`}
                      placeholder="Search"
                      id="password-input"
                      name="promotionName"
                      data-testing-Id="promotionNameInput_sellerProfileModify"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("promotionName", e);
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.promotionName}
                    />
                    {formik.touched.promotionName &&
                      formik.errors.promotionName && (
                        <div className="invalid-feedback">
                          {formik.errors.promotionName as String}
                        </div>
                      )}
                  </div>
                </div>
                <div className="input">
                  <h1>
                    Voucher Redeem Period{" "}
                    <span style={{ color: "red", display: "inline" }}>*</span>{" "}
                  </h1>
                  <Input
                    type="datetime-local"

                    className={`inputTypeEndDate form-control pe-5 password-input ${formik.touched.redeemStartPeriod &&
                        formik.errors.redeemStartPeriod
                        ? "is-invalid"
                        : ""
                      }`}
                    placeholder="Search"
                    id="password-input"
                    name="redeemStartPeriod"
                    data-testing-Id="redeemStartPeriodInput_sellerProfileModify"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("redeemStartPeriod", e);
                      handleSetDuration("week", e.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.redeemStartPeriod ? formatDateTimeLocal(formik.values.redeemStartPeriod) : ""}
                    min={formatDateTimeLocal(new Date())}
                    
                  />
                  {formik.touched.redeemStartPeriod &&
                    formik.errors.redeemStartPeriod && (
                      <div className="invalid-feedback">
                        {formik.errors.redeemStartPeriod as String}
                      </div>
                    )}
                </div>
                <div className="btn-two">
                  <button
                    className={
                      selectedDuration === "week"
                        ? "btn btn-secondary"
                        : "btn border"
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      handleSetDuration("week");
                    }}
                    data-testing-id="setWeek1_createVoucher"
                  >
                    Set Week 1
                  </button>
                  <button
                    data-testing-id="setMonth1_createVoucher"
                    className={
                      selectedDuration === "month"
                        ? "btn btn-secondary"
                        : "btn border"
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      handleSetDuration("month");
                    }}
                  >
                    Set Month 1
                  </button>
                </div>
              </div>
              <div className="input-main _Inputdiff">
                <div className="input">
                  <h1>
                    Collect Start Time{" "}
                    <span style={{ color: "red", display: "inline" }}>*</span>
                  </h1>

                  <Input
                  data-testing-id="Collect-Start"
  type="datetime-local"
  className={`inputTypeEndDate form-control pe-5 password-input ${
    formik.touched.collectStartTime && formik.errors.collectStartTime
      ? "is-invalid"
      : ""
  }`}
  placeholder="Search"
  id="password-input"
  name="collectStartTime"
  data-testing-Id="collectStartTimeInput_start-Time"
  onChange={(e) => {
    formik.handleChange(e);
    handleFieldChange("collectStartTime", e);
    handleSetDuration("week", e.target.value);

    // Auto-sync collectStartTime with collectStartTime
    formik.setFieldValue("collectStartTime", e.target.value);
  }}
  onBlur={formik.handleBlur}
  value={formatDateTimeLocal(formik.values.collectStartTime)}
  min={getMinDateTime()}
  max={formatDateTimeLocal(formik.values.redeemStartPeriod)}
  
/>

                  {formik.touched.collectStartTime &&
                    formik.errors.collectStartTime && (
                      <div className="invalid-feedback">
                        {formik.errors.collectStartTime as String}
                      </div>
                    )}
                </div>
                <div className="input">
                  <h1>
                    Voucher Apply To{" "}
                    <span style={{ color: "red", display: "inline" }}>*</span>
                  </h1>
                  <div className="d-flex gap-2">
                    <div
                      className={
                        formik.values.isEntireShop ? "btn-secondary" : "border"
                      }
                      onClick={() => formik.setFieldValue("isEntireShop", true)}
                    >
                      <input
                        data-testing-id="Entireshop_createVoucher"
                        type="radio"
                        className="radio"
                        checked={formik.values.isEntireShop}
                        onChange={() =>
                          formik.setFieldValue("isEntireShop", true)
                        }
                      />{" "}
                      Entire Shop
                    </div>

                    <div
                      className={
                        !formik.values.isEntireShop ? "btn-secondary" : "border"
                      }
                      onClick={() =>
                        formik.setFieldValue("isEntireShop", false)
                      }
                    >
                      <input
                        data-testing-id="specificProducts_createVoucher"
                        type="radio"
                        className="radio"
                        checked={!formik.values.isEntireShop}
                        onChange={() =>
                          formik.setFieldValue("isEntireShop", false)
                        }
                      />{" "}
                      Specific Products
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <Card className="VoucherCard-Main">
            <h2>Discount Setting</h2>
            <div className="VoucherCard-main">
              <div
                className={`cardVouch ${selectedCard === 0 ? "selected" : ""}`}
                onClick={() => handleCardClick(0)}
                data-test-id="moneyValueOff"
              >
                <h1>Money Value Off</h1>
                <div className="background">
                  <div>
                    <p>
                      Buypass <br /> Vouchers
                    </p>
                    {selectedCard === 0 && (
                      <h6 style={{ display: "flex", alignItems: "baseline" }}>
                        Rs .
                        <Input
                        data-testing-id="Money-spend"
                          type="number"
                          style={{
                            padding: "0px",
                            width: "80px",
                            border: "none",
                            color: "blue",
                            outline: "none",
                          }}
                          className={`inputTypeStartTime form-control pe-5 password-input ${formik.touched.flatAmount &&
                              formik.errors.flatAmount
                              ? "is-invalid"
                              : ""
                            }`}
                          placeholder="---"
                          name="flatAmount"
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("flatAmount", e);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.flatAmount}
                        />
                      </h6>
                    )}
                    <h5>
                      Min. Spend <br /> Rs{" "}
                      {selectedCard === 0
                        ? formik.values.minSpendAmount || "---"
                        : "---"}
                    </h5>
                  </div>
                  <div className="dotdot"></div>
                  <div className="tooww">
                    <button data-testing-id="Range-use-now">
                      Use Now <img src={radga} alt="" />
                    </button>
                    {formik.values.redeemEndPeriod && (
                      <p>
                        Valid until{" "}
                        {new Date(  
                          formik.values.redeemEndPeriod
                        ).toLocaleDateString()}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div
                className={`cardVouch ${selectedCard === 1 ? "selected" : ""}`}
                onClick={() => handleCardClick(1)}
                data-test-id="percentageDiscountOff"
              >
                <h1>Percentage Discount Off</h1>
                <div className="background">
                  <div>
                    <p>
                      Buypass <br /> Vouchers
                    </p>
                    {selectedCard === 1 && (
                      <h6
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "baseline",
                        }}
                      >
                        %.
                        <Input
                          type="number"
                          style={{
                            padding: "0px",
                            width: "80px",
                            border: "none",
                            color: "blue",
                            outline: "none",
                            boxShadow: "none",
                          }}
                          className={`inputTypeStartTime form-control pe-5 password-input ${formik.touched.discountPercentage &&
                              formik.errors.discountPercentage
                              ? "is-invalid"
                              : ""
                            }`}
                          data-texting-id="discountPercentage"
                          placeholder="---"
                          name="discountPercentage"
                          onChange={(e) => {
                            const value = parseInt(e.target.value, 10);

                            if (value <= 100 || isNaN(value)) {
                              formik.handleChange(e);
                              handleFieldChange("discountPercentage", e);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.discountPercentage}
                        />
                      </h6>
                    )}
                    <h5>
                      Rs{" "}
                      {selectedCard === 1
                        ? formik.values.minSpendAmount || "---"
                        : "---"}
                    </h5>
                  </div>
                  <div className="dotdot"></div>
                  <div className="tooww">
                    <button>
                      Use Now <img src={radga} alt="" />
                    </button>
                    {formik.values.redeemEndPeriod && (
                      <p>
                        Valid until{" "}
                        {new Date(
                          formik.values.redeemEndPeriod
                        ).toLocaleDateString()}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="INPUT">
              <div className="input-main">
                <div className="input">
                  <h1>
                    If Order Min. Spend{" "}
                    <span style={{ color: "red", display: "inline" }}>*</span>
                  </h1>
                  <Input
                    type="text"
                    className={`inputTypeStartTime form-control pe-5 password-input ${formik.touched.minSpendAmount &&
                        formik.errors.minSpendAmount
                        ? "is-invalid"
                        : ""
                      }`}
                    placeholder="Rs"
                    id="password-input"
                    name="minSpendAmount"
                    data-testing-Id="minSpendAmounttInput_sellerProfileModify"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("minSpendAmount", e);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.minSpendAmount}
                  />
                  {formik.touched.minSpendAmount &&
                    formik.errors.minSpendAmount && (
                      <div className="invalid-feedback">
                        {formik.errors.minSpendAmount as String}
                      </div>
                    )}
                </div>
                {selectedCard === 0 && (
                  <div className="input">
                  <h1>
                    Discount Would be{" "}
                    <span style={{ color: "red", display: "inline" }}>*</span>
                  </h1>
                  <Input
                    type="text"
                    className={`inputTypeStartTime form-control pe-5 password-input ${formik.touched.discountAmount &&
                        formik.errors.discountAmount
                        ? "is-invalid"
                        : ""
                      }`}
                    placeholder="Rs"
                    id="password-input"
                    name="discountAmount"
                    data-testing-Id="discountAmountInput_sellerProfileModify"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("discountAmount", e);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.discountAmount}
                  />
                  

                  {formik.touched.discountAmount &&
                    formik.errors.discountAmount && (
                      <div className="invalid-feedback">
                        {formik.errors.discountAmount as String}
                      </div>
                    )}
                </div>
                )}

                {selectedCard === 1 && (
                <div className="input">
                  <h1>
                    Discount Would be{" "}
                    <span style={{ color: "red", display: "inline" }}>*</span>
                  </h1>
                  <div className="position-relative">
                                      <Input
  type="number"
  max="100"
  min="0"
  className={`inputTypeStartTime form-control pe-5 password-input ${
    formik.touched.discountAmount && formik.errors.discountAmount
      ? "is-invalid"
      : ""
  }`}
  placeholder=""
  id="password-input"
  name="discountAmount"
  data-testing-Id="discountAmountInput_sellerProfileModify"
  onChange={(e) => {
    const value = e.target.value;

    // Allow only 0 to 100
    if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
      formik.setFieldValue("discountAmount", value);
      handleFieldChange("discountAmount", e);
    }
  }}
  onBlur={formik.handleBlur}
  value={formik.values.discountAmount}
/>
  <span
    style={{
      position: "absolute",
      right: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      fontWeight: "bold",
      color: "#999",
      pointerEvents: "none",
    }}
  >
    %
  </span>
                  </div>


                  {formik.touched.discountAmount &&
                    formik.errors.discountAmount && (
                      <div className="invalid-feedback">
                        {formik.errors.discountAmount as String}
                      </div>
                    )}
                </div>
                )}

                
                {selectedCard === 1 && (
                  <div className="input">
                    <h1>
                      Maximum Discount per Order{" "}
                      <span style={{ color: "red", display: "inline" }}>*</span>
                    </h1>
                    <Input
                      type="text"
                      className={`inputTypeStartTime form-control pe-5 password-input ${formik.touched.maxDiscountPerOrder &&
                          formik.errors.maxDiscountPerOrder
                          ? "is-invalid"
                          : ""
                        }`}
                      placeholder="Rs"
                      id="password-input"
                      name="maxDiscountPerOrder"
                      data-testing-Id="maxDiscountPerOrderInput_sellerProfileModify"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("maxDiscountPerOrder", e);
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.maxDiscountPerOrder}
                    />

                    {formik.touched.maxDiscountPerOrder &&
                      formik.errors.maxDiscountPerOrder && (
                        <div className="invalid-feedback">
                          {formik.errors.maxDiscountPerOrder as String}
                        </div>
                      )}
                  </div>
                )}
              </div>
              <div className="input-main _Inputdiff">
                <div className="input">
                  <h1>
                    Total Voucher to be Issued{" "}
                    <span style={{ fontWeight: "400", fontSize: "12px" }}>
                      *
                    </span>
                  </h1>
                  <Input
                    type="text"
                    className={`inputTypeStartTime form-control pe-5 password-input ${formik.touched.limitOfVouchers &&
                        formik.errors.limitOfVouchers
                        ? "is-invalid"
                        : ""
                      }`}
                    placeholder="300"
                    id="password-input"
                    name="limitOfVouchers"
                    data-testing-Id="TotalVoucherDiscountPer_sellerProfileModify"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("limitOfVouchers", e);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.limitOfVouchers}
                  />
                  {formik.touched.limitOfVouchers &&
                    formik.errors.limitOfVouchers && (
                      <div className="invalid-feedback">
                        {formik.errors.limitOfVouchers as String}
                      </div>
                    )}
                </div>
                <div className="input">
                  <h1>
                    Voucher Limit per Customer{" "}
                    <span style={{ color: "red", display: "inline" }}>*</span>
                  </h1>
                  <Input
                    type="text"
                    className={`inputTypeStartTime form-control pe-5 password-input ${formik.touched.limitPerUser && formik.errors.limitPerUser
                        ? "is-invalid"
                        : ""
                      }`}
                    placeholder="1"
                    id="password-input"
                    name="limitPerUser"
                    data-testing-Id="VoucherLimit_sellerProfileModify"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("limitPerUser", e);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.limitPerUser}
                  />
                  {formik.touched.limitPerUser &&
                    formik.errors.limitPerUser && (
                      <div className="invalid-feedback">
                        {formik.errors.limitPerUser as String}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="btn-two">
              {formik.values.isEntireShop ? (
                <button
                  type="submit"
                  className="fbbb"
                  data-testing-Id="submitButton_entireShop"
                >
                  {formik.values.id ? "Update" : "Submit"}
                </button>
              ) : (
                <Link
                  to="/Manage-product"
                  state={{
                    ...formik.values,
                    discountType:
                      selectedCard === 0 ? "flatDiscount" : "percentage",
                  }}
                >
                  <button
                    type="button"
                    className="fbbb"
                    data-testing-Id="submitButton_specificProducts"
                  >
                    Submit
                  </button>
                </Link>
              )}

              <button
                onClick={() => handleback()}
                className="bfff"
                data-testing-Id="submitButton_sellerProfileModify"
              >
                Cancel
              </button>
            </div>
          </Card>
        </form>
      </Container>
    </div>
  );
};

export default CreateVoucher;
